import { config, debug, i18n, inject, observer, React, Route, RouteComponentProps, ui } from "aaa";
import { NewPhone } from "components/common/NewPhone";
import auth from "stores/AuthStore";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { ShowCardDataDetails } from "./ShowCardDataDetails";
import { ShowCardDataLandingPage } from "./ShowCardDataLandingPage";
import { ShowCardDataRoutes } from "./ShowCardDataRoutes";
import { ShowCardDataSigning } from "./ShowCardDataSigning";
import ShowCardDataResetStore from "./ShowCardDataStore";
import { ShowCardDataSuccess } from "./ShowCardDataSuccess";

type IProps = RouteComponentProps<{}> & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export class ShowCardDataContainer extends React.Component<IProps, {}> {
    store: ShowCardDataResetStore;

    constructor(props: any) {
        super(props);
        this.store = new ShowCardDataResetStore();
    }

    async componentDidMount() {
        pushRoute(ShowCardDataRoutes.ROOT);

        try {
            if (auth.authorized && this.props.externalInterfaceStore.currentCardId) {
                await this.store.load(this.props.externalInterfaceStore.currentCardId);
            }
        } catch (error) {
            debug.log("### Container.componentDidMount() Failed to load data", error);
            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.store} />;
    }

    withContactsStore(Component: any) {
        return () => <Component {...this.props} contactsStore={this.store.contactsStore} />;
    }

    render() {
        document.title = ui.__("showCardData.document.title");

        return (
            <div>
                <Route exact path={ShowCardDataRoutes.ROOT} render={this.withStore(ShowCardDataLandingPage)} />
                <Route path={ShowCardDataRoutes.SIGNING} render={this.withStore(ShowCardDataSigning)} />
                <Route path={ShowCardDataRoutes.DETAILS} render={this.withStore(ShowCardDataDetails)} />
                <Route path={ShowCardDataRoutes.SUCCESS} render={this.withStore(ShowCardDataSuccess)} />
                <Route exact path={ShowCardDataRoutes.NEW_PHONE} component={this.withContactsStore(NewPhone)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/showCardData/ShowCardDataContainer.tsx